import { render, staticRenderFns } from "./OperaMemberDetail.vue?vue&type=template&id=6160d84f&scoped=true&"
import script from "./OperaMemberDetail.vue?vue&type=script&lang=js&"
export * from "./OperaMemberDetail.vue?vue&type=script&lang=js&"
import style0 from "./OperaMemberDetail.vue?vue&type=style&index=0&id=6160d84f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6160d84f",
  null
  
)

export default component.exports